<template>
  <div class="s-setting-container">
    <div class="main-header">
      <div>Primary Address</div>
      <div v-if="adminRole === 'admin'">
        <button
          class="address-icn-btn"
          @click="toggleActionModal(true, 'edit-address', {})"
        >
          <v-icon
            color="#4979FF"
            dark
            small
          >
            mdi-pencil-outline
          </v-icon>
          Edit
        </button>
      </div>
    </div>
    <BusinessAddress
      :currentCorporation="currentCorporation"
      :states="states"
      :countries="countries"
      :onChange="handleChange"
    />
    <AddressModal
      type="BUSINESS"
      :show="showModal"
      :view="modalView"
      :toggle="toggleActionModal"
      :address="currentCorporation"
      :states="states"
      :update="update"
    />
  </div>
</template>

<script>
import partnerSettingsMixin from '@shared/mixins/partnerSettingsMixin';

import BusinessAddress from '@shared/components/partnerSettings/BusinessAddress.vue';
import AddressModal from './shippingModal/AddressModal.vue';

export default {
  name: 'BusinessAddressSection',
  components: {
    BusinessAddress,
    AddressModal,
  },
  mixins: [partnerSettingsMixin],
  props: {
    currentCorporation: Object,
    update: Function,
    states: Array,
    countries: Array,
  },
  data() {
    return {
      errorObj: Object,
      address: {},
      showModal: false,
      modalView: '',
    };
  },
  computed: {
    changeCheck() {
      let changes = false;
      Object.keys(this.currentCorporation).forEach((key) => {
        if (this[key] !== undefined && this.currentCorporation[key] !== this[key]) {
          changes = true;
        }
      });
      if (!changes) {
        this.changePartnerSettingsValue('showWarningOnExit', false);
      } else if (changes && !this.showWarningOnExit && !this.warningTab) {
        this.changePartnerSettingsValue('showWarningOnExit', true);
      }
      return changes;
    },
  },
  methods: {
    handleChange(field, value) {
      if (field === 'address') {
        Object.keys(value).forEach((k) => {
          if (this[k] !== undefined) {
            this[k] = value[k];
          }
        });
      } else {
        this[field] = value;
      }
    },
    toggleActionModal(show, view, address) {
      this.showModal = show;
      if (show) {
        this.modalView = view;
        this.address = address;
      } else {
        this.address = {};
      }
    },
  },
};
</script>
